export default "__VITE_ASSET__CXnwlPTJ__"